import Vue from 'vue'

import {
    ACCESS_TOKEN,
    UER_ROLE,
    USER_ID,
    USER_LEVEL,
    USER_NAME,
    SYSTEM_IMAGE,
    SYSTEM_NAME,
    USER_IMAGE,
    SET_HOME_MAP,
    SET_HOME_SOLD,
    SET_HOME_STOCK,
    ORG_NAME,
    SET_LANG,
    SET_NOTICE_TYPE,
} from './mutation-types'


export default {
    [SET_HOME_SOLD]: (state, data) => {
        state.selledData = data
    },
    [SET_HOME_STOCK]: (state, data) => {
        state.stockData = data
    },
    [SET_HOME_MAP]: (state, data) => {
        state.mapData = data
    },
    [SET_LANG]: (state, lang) => {
      state.lang = lang
    },
    [SET_NOTICE_TYPE]: (state, type) => {
      state.alarmNoticeType = type
    },
    initAlarmConfig: (state, configs) => {
      state.alarmConfig = configs
    },
    setAlarmConfig: (state, config) => {
      if (state.alarmConfig.length > 0) {
        let index = state.alarmConfig.findIndex((item) => item.id === config.id)
        state.alarmConfig[index] = config
      }
    },
    setOpenedInfoBoxId: (state, id) => {
      if (id) {
        state.openedInfoBoxId = id
      } else {
        state.openedInfoBoxId = ''
      }
    },
    SET_USER: (state, payload) => {
        state.user = payload;
        Vue.ls.set(UER_ROLE, payload.roles);
        Vue.ls.set(USER_ID, payload.id);
        Vue.ls.set(USER_NAME, payload.name);
        Vue.ls.set(USER_IMAGE, payload.userImage);
    },
    GET_USER: (state, payload) => {
        state.user = payload
    },
    SET_ORG: (state, payload) => {
        state.org = payload;
        Vue.ls.set(USER_LEVEL, payload.level);
        Vue.ls.set(SYSTEM_IMAGE, payload.systemImage);
        Vue.ls.set(SYSTEM_NAME, payload.systemName);
        Vue.ls.set(ORG_NAME, payload.orgName);
    },
    GET_ORG: (state, payload) => {
        state.org = payload
    },
    SET_TOKEN: (state, payload) => {
        state.token = payload.token;
        // Vue.ls.set(ACCESS_TOKEN, payload.token);
        localStorage.setItem(ACCESS_TOKEN, payload.token)
        if (payload.expire > 0) {
          localStorage.setItem('TOKEN_EXPIRE', payload.expire)
        }
    },
    GET_TOKEN: (state, payload) => {
        state.token = payload
    },
    SET_LEVEL: (state, payload) => {
        state.level = payload;
        Vue.ls.set(USER_LEVEL, payload);
    },
    GET_LEVEL: (state, payload) => {
        state.level = payload
    },
    SET_TITLE_NAME: (state, payload) => {
        state.titleName = payload
    },
    SET_ORGCOORD: (state, payload) => {
      state.orgCoord = payload
    },
    LOGOUT: (state) => {
        state.user = {};
        /*
        Vue.ls.remove('roles');
        Vue.ls.remove('userId');
        Vue.ls.remove('userName');
        Vue.ls.remove('Token');
        Vue.ls.remove('logo');
        Vue.ls.remove('title');
        Vue.ls.remove('level');
        state.token = null;
        */
        Vue.ls.clear();
    }

}
